import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/App';
import './css/build.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
